module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kerry Newcomb\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kerry Newcomb was born in Milford, Connecticut, but had the good fortune to be raised in Texas. He has served in the Jesuit Volunteer Corps and taught at the St. Labre Mission School on the Northern Cheyenne Reservation in Montana, and holds a master’s of fine arts degree in theater from Trinity University. Newcomb has written plays, film scripts, commercials, and liturgical dramas, and is the author of over thirty novels. He lives with his family in Fort Worth, Texas."), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rKO6yA/tc-custom/9781480478848.jpg?1733033566726",
      "alt": "This image is the cover for the book Jack Iron, The Medal"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Jack Iron, The Medal\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("To save New Orleans from the British, a soldier makes a pact with a pirate")]), _c('br'), _c('br'), _vm._v("In 1815, the fate of the young American nation will be determined at New Orleans. As the British mass their forces at the mouth of the Mississippi, General Andrew Jackson accepts volunteers from all over the country to help defend the Crescent City from invasion. And of all the ragtag men who heed Jackson’s call to arms, there is no fighter fiercer than the swashbuckling adventurer known as Kit McQueen."), _c('br'), _c('br'), _vm._v("While surveying fortifications south of the city, Kit is ambushed and then abandoned by his closest friend, who returns to New Orleans to steal away the woman Kit loves. With the British in front of him and a traitorous comrade at his rear, Kit finds an unlikely ally: the pirate king Jean Lafitte. His army of freebooters will give their all to save Kit’s country and rescue his beloved—but what price will these scoundrels demand?"), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0